import { useContext, useState } from "react";
import { NavBar } from "./home_page";
import img1 from "../../assets/images/b1.jpeg";
import img2 from "../../assets/images/b2.jpeg";
import img3 from "../../assets/images/b3.jpeg";
import img4 from "../../assets/images/b4.jpeg";
import img5 from "../../assets/images/b5.jpeg";
import img6 from "../../assets/images/b6.jpeg";
import { uuid } from "./projects_page";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { db, storage } from "../../firebase";
import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  query,
  setDoc,
} from "firebase/firestore";
import { CurrentUserContext } from "../../App";
import React from "react";
import { ConfirmatinDialog } from "./info_page";

const images = [img1, img2, img3, img4, img5, img6];

interface Formation {
  id: string;
  title: string;
  description: string;
  image: string | null;
}

function FormationDialog({ onSubmit }: { onSubmit: () => void }) {
  const [img, setImg] = useState<{ file: File; url: string } | null>(null);
  const [title, setTitle] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [isUploading, setIsUploading] = useState(false);

  async function uploadNew() {
    setIsUploading(true);
    const ext = img?.file.name.split(".").pop();
    const uid = uuid();
    const imageRef = ref(storage, `formations/${uid}.${ext}`);

    try {
      await setDoc(doc(db, "formations", uid), {
        title,

        image: `formations/${uid}.${ext}`,
        description: description,
      });

      await uploadBytes(imageRef, img?.file as Blob);
    } catch (e) {
      console.error(e);
    }
    setIsUploading(false);
    onSubmit();
  }

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
      className="bg-white shadow-xl rounded-xl p-4 w-[600px] aspect-[3/2] flex-col flex gap-y-2"
    >
      <div className="flex items-center justify-center w-full">
        {img ? (
          <img
            className="w-full h-64 rounded-xl shadow-xl object-cover "
            src={img.url}
          />
        ) : (
          <label className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50  hover:bg-gray-100">
            <div className="flex flex-col items-center justify-center pt-5 pb-6">
              <svg
                className="w-8 h-8 mb-4 text-gray-500 "
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 16"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                />
              </svg>

              <p className="text-xs text-gray-500 ">SVG, PNG, JPG</p>
            </div>
            <input
              onChange={(e) => {
                const file = e.target.files?.item(0);

                if (file) {
                  const reader = new FileReader();
                  reader.onload = (e) => {
                    setImg({
                      file: file,
                      url: e.target?.result as string,
                    });
                  };
                  reader.readAsDataURL(file);
                }
              }}
              id="dropzone-file"
              type="file"
              className="hidden"
            />
          </label>
        )}
      </div>
      <input
        placeholder="Titre"
        className=" text-xl py-2 focused:px-4"
        value={title}
        onChange={(
          e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        ) => setTitle(e.target.value)}
      />
      <input
        placeholder="Description"
        onChange={(
          e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        ) => setDescription(e.target.value)}
        className=" text-md py-2 focused:px-4"
        value={description}
      />

      <button
        onClick={uploadNew}
        disabled={title === "" || img === null || isUploading}
        className={`bg-blue-500 rounded-full w-min text-white py-2 px-4 self-end hover:bg-blue-600 active:scale-95 transition-all disabled:bg-gray-500 ${
          isUploading ? " animate-pulse" : ""
        }`}
      >
        {isUploading ? "Téléchargement..." : "Ajouter"}
      </button>
    </div>
  );
}

function FormationItem({
  item,
  onDeleteClick,
}: {
  item: Formation | null;
  onDeleteClick: () => void;
}) {
  const user = useContext(CurrentUserContext).user;
  return (
    <div
      className={`relative flex-col items-start  w-[94%] 2xl:w-[480px]  ${
        !item ? "animate-pulse" : ""
      }`}
    >
      {/* delete icon button */}
      {item && user && (
        <button
          onClick={(e) => {
            e.stopPropagation();

            onDeleteClick();
          }}
          className="absolute -top-3 -right-3 bg-red-500 rounded-full w-8 h-8 flex items-center justify-center text-white hover:bg-red-600 transition-all active:scale-95 hover:scale-110"
        >
          <svg
            className="w-6 h-6 text-white "
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L10 8.586 7.707 6.293a1 1 0 00-1.414 1.414L8.586 10l-2.293 2.293a1 1 0 101.414 1.414L10 11.414l2.293 2.293a1 1 0 001.414-1.414L11.414 10l2.293-2.293z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
      )}
      {item && item.image ? (
        <img
          className="w-full h-96 rounded-xl shadow-xl object-cover "
          src={item.image}
        />
      ) : (
        <div className="flex items-center justify-center h-96 w-full bg-gray-300 rounded-xl">
          <svg
            className="w-10 h-10 text-gray-200 "
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 16 20"
          >
            <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z" />
            <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" />
          </svg>
        </div>
      )}
      {item ? (
        <h3 className=" text-xl text-left mt-6 line-clamp-2 font-medium">
          {item.title}
        </h3>
      ) : (
        <div className="h-2.5 bg-gray-200 rounded-full  w-96 mt-6"></div>
      )}
      {item ? (
        <h6 className="text-gray-700 font-semibold mb-2  text-left ">
          {item.description}
        </h6>
      ) : (
        <div className="h-2.5 bg-gray-200 rounded-full w-56 mt-2"></div>
      )}
    </div>
  );
}

export function GalleryPage() {
  const [selected, setSelected] = useState<number | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const user = useContext(CurrentUserContext).user;
  const [data, setData] = useState<Formation[] | null>([]);
  const [deletingDoc, setDeletingDoc] = useState<string | null>(null);

  async function fetch() {
    setData(null);
    var q = query(collection(db, "formations"));

    let ret: Formation[] = [];
    const querySnapshot = await getDocs(q);
    for (const doc of querySnapshot.docs) {
      const data = doc.data();

      const image = ref(storage, data.image);
      let url = null;
      try {
        url = await getDownloadURL(image);
      } catch (e) {
        console.error(e);
      }

      ret.push({
        id: doc.id,
        title: data.title,
        image: url,
        description: data.description,
      });
    }

    setData(ret);
  }

  React.useEffect(() => {
    fetch();
  }, []);

  return (
    <div className="relative flex flex-col">
      {selected !== null && (
        <div
          onClick={() => {
            setSelected(null);
          }}
          className="absolute inset-0 flex items-center backdrop-blur-sm h-screen shadow-xl z-10 "
        >
          <img
            className=" rounded-lg h-1/2 self-center m-auto"
            src={images[selected]}
            alt=""
          />
        </div>
      )}
      {(isDialogOpen || deletingDoc) && (
        <div
          onClick={() => {
            setIsDialogOpen(false);
          }}
          className=" absolute inset-0 flex justify-center items-center backdrop-blur-sm z-50"
        >
          {deletingDoc ? (
            <ConfirmatinDialog
              onSubmit={function (): void {
                setDeletingDoc(null);
                deleteDoc(doc(db, "formations", deletingDoc)).then(() => {
                  fetch();
                });
              }}
              onCancel={function (): void {
                setDeletingDoc(null);
              }}
            />
          ) : (
            <FormationDialog
              onSubmit={function (): void {
                setIsDialogOpen(false);
                fetch();
              }}
            />
          )}
        </div>
      )}
      <NavBar />
      <div className="flex justify-between gap-x-2 items-center w-full px-4">
        <h3 className=" text-4xl font-semibold my-12 self-start text-slate-700 ">
          Nos Formations
        </h3>
        {user && (
          <button
            onClick={() => {
              setIsDialogOpen(true);
            }}
            className="border border-blue-500 rounded-full py-2 px-4 font-semibold text-blue-600 transition-all hover:bg-blue-500 hover:text-white active:scale-95"
          >
            Ajouter
          </button>
        )}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 2xl:grid-cols-3 justify-items-center 2xl:gap-x-4 gap-y-12 w-full  ">
        {data?.map((item) => (
          <FormationItem
            item={item}
            onDeleteClick={() => {
              setDeletingDoc(item.id);
            }}
          />
        )) ??
          [1, 2, 3].map((_) => (
            <FormationItem item={null} onDeleteClick={() => {}} />
          ))}
      </div>
      {/* {images.map((image, index) => (
          <div
            onClick={() => {
              setSelected(index);
            }}
          >
            <img
              className="h-auto hover:scale-[1.02] transition-all max-w-full rounded-lg cursor-pointer"
              src={image}
              alt=""
            />
          </div>
        ))} */}
    </div>
  );
}
